'use client'

import React, { useCallback } from 'react'
import { ProductGroupsArchiveClientProps } from './types'
import { CardType } from '@/ui/components/Card/types'
import { mapProductGroupsToCardProps } from './mapper'
import { CollectionArchive } from '@/ui/components/CollectionArchive'
import { FetchDataParams } from '@/lib/actions/fetchCollectionData'

/**
 * Client component for ProductGroupsArchive
 *
 * Simplified client component that delegates all logic to CollectionArchive.
 * All gating, authentication, and rendering logic is now handled by the
 * generic CollectionArchive component.
 */
export const ProductGroupsArchiveClient: React.FC<ProductGroupsArchiveClientProps> = ({
  initialData,
  fetchCollectionDataAction,
  isGated,
  gateConfig,
  where,
  locale,
  limit,
  gridCols,
  filters = [],
  filterField = 'category',
  filterTitle,
  archiveId = 'product-groups',
  excludeProcessId,
  emptyStateType,
  emptyStateButton,
  emptyStateHasButton,
}) => {
  // Wrap fetch action to inject excludeProcessId
  const fetchDataWithExclude = useCallback(
    async (params: FetchDataParams) => {
      return fetchCollectionDataAction({
        ...params,
        excludeProcessId,
      } as any)
    },
    [fetchCollectionDataAction, excludeProcessId],
  )

  return (
    <CollectionArchive
      archiveId={archiveId}
      initialData={initialData}
      fetchCollectionDataAction={fetchDataWithExclude}
      collection="product-groups"
      locale={locale}
      where={where}
      limit={limit}
      gridCols={gridCols}
      filter={filters}
      filterField={filterField}
      filterTitle={filterTitle}
      cardType={CardType.Teaser}
      mapper={mapProductGroupsToCardProps}
      loadMoreStrategy="pagination"
      // Gating props
      isGated={isGated}
      gateConfig={gateConfig}
      // Empty state props
      emptyStateType={emptyStateType}
      emptyStateButton={emptyStateButton}
      emptyStateHasButton={emptyStateHasButton}
    />
  )
}
